import { render, staticRenderFns } from "./CommentFormTextArea.vue?vue&type=template&id=52e887c0&"
import script from "./CommentFormTextArea.vue?vue&type=script&lang=js&"
export * from "./CommentFormTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports